export const normalizeSsin = (value?: string): string => {
  if (!value) {
    return '';
  }

  return value.replace(/\D/g, '');
};

export const isValidSsin = (value?: string): boolean => {
  const normalizedSsin = normalizeSsin(value);

  if (!normalizedSsin) {
    return true;
  }

  if (normalizedSsin.length !== 11) {
    return false;
  }

  const first9Digits = normalizedSsin.substring(0, 9);
  const checkDigits = normalizedSsin.substring(9, 11);

  const first9Num = parseInt(first9Digits, 10);
  const checkDigitsNum = parseInt(checkDigits, 10);

  const control1 = 97 - (first9Num % 97);
  const control2 = 97 - ((2000000000 + first9Num) % 97);

  return checkDigitsNum === control1 || checkDigitsNum === control2;
};

export const calculateAge = (birthDate?: string | Date): number | string => {
  if (!birthDate) {
    return '';
  }

  const birth = new Date(birthDate);
  if (isNaN(birth.getTime())) {
    return '';
  }

  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age;
};

export const calculateAgeYearsMonths = (
  birthDate?: string | Date,
): { years: number; months: number } | null => {
  if (!birthDate) {
    return null;
  }

  const birth = new Date(birthDate);
  if (isNaN(birth.getTime())) {
    return null;
  }

  const today = new Date();
  let totalMonths = (today.getFullYear() - birth.getFullYear()) * 12 + today.getMonth() - birth.getMonth();

  if (today.getDate() < birth.getDate()) {
    totalMonths--;
  }

  if (totalMonths < 0) {
    return null;
  }

  return { years: Math.floor(totalMonths / 12), months: totalMonths % 12 };
};

export const deriveBirthDateFromSsin = (ssin?: string): string => {
  if (!ssin) {
    return '';
  }

  const normalizedSsin = ssin.replace(/\D/g, '');
  if (normalizedSsin.length < 6) {
    return '';
  }

  const yy = parseInt(normalizedSsin.substring(0, 2), 10);
  const mm = parseInt(normalizedSsin.substring(2, 4), 10);
  const dd = parseInt(normalizedSsin.substring(4, 6), 10);

  if (mm < 1 || mm > 12 || dd < 1 || dd > 31) {
    return '';
  }

  const yearPrefix = yy > 26 ? 1900 : 2000;
  const year = yearPrefix + yy;

  return `${year}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
};
